import React, { FC } from 'react';

import { Trans, useTranslation } from 'react-i18next';
import { CallCenter } from 'src/front/api/apiInstance';

import { Separator, Title } from 'src/front/components/FormStyles';
import AccountSelectionFormIntrabank from './componenets/AccountSelectionFormIntrabank';

interface Props {
  goToNextStep: () => void;
}

const logScreenOnce = (): (() => Promise<void>) => {
  let count = 0;

  const logScreen = async (): Promise<void> => {
    if (count === 0) {
      await CallCenter.logScreen({ screenCode: 'CEA30002' });
      count += 1;
    }
  };

  return logScreen;
};
const logScreen = logScreenOnce();

const AccountSelectionIntrabank: FC<Props> = ({ goToNextStep }) => {
  const { t } = useTranslation();

  const onContinue = async (): Promise<void> => {
    goToNextStep();
  };

  return (
    <>
      <Title>
        <Trans i18nKey={t('callCenter_internetBanking_intrabankMoneyTransfersHistory_title')} />
      </Title>
      <Separator />

      <AccountSelectionFormIntrabank logScreen={logScreen} onContinue={onContinue} />
    </>
  );
};

export default AccountSelectionIntrabank;
